import { render, staticRenderFns } from "./CaseFilters.vue?vue&type=template&id=284d5262&"
import script from "./CaseFilters.vue?vue&type=script&lang=js&"
export * from "./CaseFilters.vue?vue&type=script&lang=js&"
import style0 from "./CaseFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports